// @ts-nocheck
import { useCallback, useEffect, useRef, useState } from 'react';
import { getSessionUserEmail } from '../config/common';
import { toast } from 'react-toastify';
import { isEmptyObject, isSystemFeedItem, sanitizeCommentBody } from '../utils/helpers';
import { useAppDispatch } from '../hooks';
import * as changeRequestRequiredListAction from '../Action/Change_Request_Required_List/Change_Request_Required_List_Action';
import * as changeRequestListAction from '../Action/Change_Request_List/Change_Request_List_Action';
import * as changeRequestCommentListAction from '../Action/Change_Request_Comments_List/Change_Request_Comments_List_Action';
import * as changeRequestCommentAddAction from '../Action/Change_Request_Comments_Add/Change_Request_Comments_Add_Action';
import * as changeRequestCommentAddReplyAction from '../Action/Change_Request_Comments_Add_Reply/Change_Request_Comments_Add_Reply_Action';
import * as changeRequestUploadFileAction from '../Action/Change_Request_Upload_File/Change_Request_Upload_File_Action';
import Loader from './Loader';
import FilePreviewModal, { shouldOpenFileInPreviewModal } from './FilePreviewModal';
import FeedBody, { useRecordFileCache } from './FeedBody';
import FeedAttachments from './FeedAttachments';
import { FILE_MESSAGES, openRecordAttachment } from '../utils/recordFiles';
import dayjs from 'dayjs';
import DOMPurify from "dompurify";

function commentInitials(name) {
    if (!name || typeof name !== 'string') return '?';
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

const ChangeRequestTab = ({ id, navKey, tab, onNavigate, onCloseDetail }) => {
    const dispatch = useAppDispatch();
    const [data, setData] = useState({
        urgencyList: [],
        statusList: [],
        userEmail: getSessionUserEmail()
    });
    const [changeRequestList, setChangeRequestList] = useState([]);
    const [changeRequestModal, setChangeRequestModal] = useState(false);
    const [filePreviewModal, setFilePreviewModal] = useState(false);
    const [viewChangeRequestModal, setViewChangeRequestModal] = useState(false);
    const [pagination, setPagination] = useState({
        pageNo: 1,
        totalPage: 1,
        pageSize: 10
    });
    const [changeRequestDetails, setChangeRequestDetails] = useState({});
    const [changeRequestCommentList, setChangeRequestCommentList] = useState([]);
    const [filterParam, setFilterParam] = useState({
        crName: '',
        seletedStatus: '',
        sortType: 'Recent',
        searchText: '',
        urgency: '',
        hideClosed: false,
        incApproved: false
    });
    const [isLoading, setIsLoading] = useState(true);
    const hasFetched = useRef();
    const crChatterSortRef = useRef(null);
    const fileUploadRef = useRef(null);
    /* ACOP-123: the open CR's inline images and attachment preview, revoked on close/switch/unmount. */
    const { imageCache, cacheVersion: imageCacheVersion, onImagesSettled } = useRecordFileCache(changeRequestDetails.Id);
    const previewFileModalRef = useRef(null);
    const openAttachmentRef = useRef(null);

    useEffect(() => {
        if(hasFetched.current) return;
        hasFetched.current = true;

        getRequiredData(getChangeRequestList);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    useEffect(() => {
        if (!hasFetched.current || !id) return;
        setIsLoading(true);
        setChangeRequestCommentList([]);
        const param = { email: getSessionUserEmail(), id };
        dispatch(changeRequestListAction.change_request_list({ data: JSON.stringify(param) })).then((response) => {
            if (response.status !== 1) { setIsLoading(false); toast.error(response.message); return; }
            if (!response.data.changerequestList || response.data.changerequestList.length === 0) {
                toast.error('Unauthorized: You do not have access to this change request.');
                onCloseDetail && onCloseDetail();
                loadChangeRequestListPage(1);
                return;
            }
            setIsLoading(false);
            response.data.changerequestList.forEach(item => {
                setChangeRequestList([item]);
                setChangeRequestDetails(item);
                setIsLoading(true);
                getCommentsList(item.Id);
            });
            setViewChangeRequestModal(true);
            setChangeRequestModal(true);
        }).catch(error => { setIsLoading(false); toast.error(error.message); });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, navKey]);

    const getRequiredData = async (callback) => {
        var param = {};
        param.email = getSessionUserEmail();
        dispatch(changeRequestRequiredListAction.change_request_required_list({ data: JSON.stringify(param) })).then((response) => {
            if (response.status === 1) {
                setData({...data, urgencyList: response.data.changerequestUrgencyList || [], statusList: response.data.changerequestStatusList || []});
            }
            if (callback) {
                callback(pagination.pageNo);
            } else {
                setIsLoading(false);
            }
        }).catch(error => {
            toast.error(error.message);
        })
    };

    const getChangeRequestList = async (pageNo, filter = filterParam) => {
        // eslint-disable-next-line no-unused-vars
        let changeRequestViewModal = false;
        if(id && !viewChangeRequestModal && tab === 'changeRequest'){
            var param = {}
            param.email = getSessionUserEmail();
            param.id = id || null;
            dispatch(changeRequestListAction.change_request_list({ data: JSON.stringify(param) })).then((response) => {
                setIsLoading(false);
                if (response.status !== 1) {
                    toast.error(response.message);
                    return;
                }
                if (!response.data.changerequestList || response.data.changerequestList.length === 0) {
                    toast.error('Unauthorized: You do not have access to this change request.');
                    onCloseDetail && onCloseDetail();
                    loadChangeRequestListPage(pageNo, filter);
                    return;
                }
                response.data.changerequestList.forEach(item => {
                    setChangeRequestList([item]);
                    setChangeRequestDetails(item);
                    setIsLoading(true);
                    getCommentsList(item.Id);
                    changeRequestViewModal = true;
                })
                setViewChangeRequestModal(true);
                setChangeRequestModal(true);
            }).catch(error => {
                toast.error(error.message);
            })
        } else {
            loadChangeRequestListPage(pageNo, filter);
        }
    };

    const loadChangeRequestListPage = (pageNo, filter = filterParam) => {
        let param = { ...filter };
        param.searchText = encodeURIComponent(param.searchText);
        param.pageSize = pagination.pageSize;
        param.pageNo = pageNo;
        param.email = getSessionUserEmail();
        dispatch(changeRequestListAction.change_request_list({ data: JSON.stringify(param) })).then((response) => {
            setIsLoading(false);
            if (response.status !== 1) {
                toast.error(response.message);
                return;
            }
            setChangeRequestList(response.data.changerequestList);
            if (response.data.totalPage) {
                setPagination((prev) => ({
                    ...prev,
                    totalPage: response.data.totalPage
                }))
            }
        }).catch(error => {
            toast.error(error.message);
        })
    };

    const handleInputChange = (e) => {
        setFilterParam({...filterParam, [e.target.name]: e.target.value, incApproved: true});
    }

    const handleHideClosedChange = (e) => {
        setFilterParam({ ...filterParam, hideClosed: e.target.checked, incApproved: true });
    };

    const onApplyFilter = () => {
        setIsLoading(true);
        setPagination((prev) => ({
            ...prev,
            pageNo: 1
        }));
        getChangeRequestList(1);
    };

    const clearFilter = () => {
        setIsLoading(true);
        let filter = {
            crName: '',
            seletedStatus: '',
            sortType: 'Recent',
            searchText: '',
            urgency: '',
            hideClosed: false,
            incApproved: false
        };
        setFilterParam(filter);
        getChangeRequestList(1, filter);
    };

    const sortCRComments = (e) => {
        let value = e.target.value;
        setIsLoading(true);
        getCommentsList(changeRequestDetails.Id, value);
    }

    const postNewCRComment = (e) => {
        e.preventDefault();
        let caseId = e.target.crCommentId.value;
        let comment = e.target.crChatterNewPost.value;
        let params = {
            email: getSessionUserEmail(),
            crId: caseId,
            comment: comment
        };
        setIsLoading(true);
        dispatch(changeRequestCommentAddAction.change_request_comments_add({ data: JSON.stringify(params) })).then((response) => {
            if (response.status !== 1) {
                setIsLoading(false);
               toast.error(response.message);
                return;
            }
            getCommentsList(caseId, crChatterSortRef.current?.value || 'Most Recent Activity');
            e.target.crChatterNewPost.value = '';
        }).catch(error => {
            console.log(error);
            toast.error(error.message);
        })
    }

    const getCommentsList = async (changeRequestId, value = 'Most Recent Activity') => {
        var param = {};
        param.email = getSessionUserEmail();
        param.sortType = value;
        param.crId = changeRequestId;
        dispatch(changeRequestCommentListAction.change_request_comments_list({ data: JSON.stringify(param) })).then((response) => {
            if (response.status === 1) {
                setChangeRequestCommentList(response.data);
            }
            setIsLoading(false);
        }).catch(error => {
            toast.error(error.message);
        })
    };

    const addReply = async(e) => {
        e.preventDefault();
        let replyId = e.target.replyId.value;
        let reply = e.target.reply.value;
        let params = {
            email: getSessionUserEmail(),
            commentId: replyId,
            reply: reply
        };
        setIsLoading(true);
        dispatch(changeRequestCommentAddReplyAction.change_request_comments_add_reply({ data: JSON.stringify(params) })).then((response) => {
            if (response.status !== 1) {
                setIsLoading(false);
                toast.error(response.message);
                return;
            }
            getCommentsList(changeRequestDetails.Id, crChatterSortRef.current?.value || 'Most Recent Activity');
            e.target.reply.value = '';
        }).catch(error => {
            console.log(error);
            toast.error(error.message);
        })
    }

    const changePage = (pageNo) => {
        setPagination((prev) => ({
            ...prev,
            pageNo: pageNo
        }));
        getChangeRequestList(pageNo);
        setIsLoading(true);
    };

    const handleFileUpload = async (e) => {
        if (!fileUploadRef.current || fileUploadRef.current.files.length === 0) {
            toast.error('Please select file to upload');
            return;
        }
        const file = fileUploadRef.current.files[0];

        if (file.size > 2097152) { // 2MB in bytes
            toast.error('File size should not exceed 2MB');
            return;
        }

        setIsLoading(true);

        const reader = new FileReader();
        reader.onload = () => {
            let params = {
                email: getSessionUserEmail(),
                crId: changeRequestDetails.Id,
                fileName: file.name.replace(/[^a-zA-Z0-9 ._-]/g, '')
            };
            let base64File = reader.result.split('base64,')[1];

            dispatch(changeRequestUploadFileAction.change_request_upload_file(params, base64File)).then((response) => {
                setIsLoading(false);
                if (response.status !== 1) {
                    toast.error(response.message);
                    return;
                }
                if (fileUploadRef.current) {
                    fileUploadRef.current.value = '';
                }
                changeRequestDetails.fileList.push(response.data);
            }).catch(error => {
                console.log(error);
                toast.error(error.message);
            })
        };
        reader.readAsDataURL(file);
    };


    /* CHANGE REQUEST MODAL */
    function openChangeRequestModal(item) {
        setChangeRequestDetails(item);
        setChangeRequestModal(true);
        setIsLoading(true);
        getCommentsList(item.Id);
    }
    function closeChangeRequestModal(resetRoute = true) {
        setChangeRequestDetails({});
        setChangeRequestCommentList([]);
        setChangeRequestModal(false);
        if (resetRoute) {
            onCloseDetail && onCloseDetail();
        }
    }

    /* Click-to-zoom on a feed image (FeedBody passes the loaded src). Stable, so memoised bodies skip unrelated re-renders. */
    const handleCommentImageClick = useCallback((src, name) => {
        previewFileModalRef.current(src, name, 'image');
    }, []);

    /* ACOP-123: a file attached to a post or reply opens exactly as its Attachments entry does. Stable, like the image click above. */
    const handleFeedAttachmentOpen = useCallback((file) => {
        openAttachmentRef.current(file);
    }, []);

    function openChangeRequestAttachment(file) {
        const name = file.name || file.Name || '';
        if (!file.docId) {
            // Release window (D8): until the Salesforce half ships, list items still carry filePublicUrl.
            openLegacyAttachment(file.filePublicUrl, name);
            return;
        }
        openRecordAttachment('changeRequest', changeRequestDetails.Id, file, { cache: imageCache, onPreview: previewFileModal, onBusy: setIsLoading });
    }
    openAttachmentRef.current = openChangeRequestAttachment;

    function openLegacyAttachment(fileUrl, name) {
        if (!fileUrl) {
            toast.error(FILE_MESSAGES.unavailable);
            return;
        }
        if (shouldOpenFileInPreviewModal(name, fileUrl)) {
            previewFileModal(fileUrl, name);
        } else {
            window.open(fileUrl, '_blank', 'noopener,noreferrer');
        }
    }

    /* File Preview Modal (images + PDF only). `kind` is set for proxy blob: URLs, which carry no extension. */
    function previewFileModal(fileUrl, fileName, kind) {
        setData((prev) => ({ ...prev, curFileUrl: fileUrl, curFileName: fileName || '', curFileKind: kind }));
        setFilePreviewModal(true);
        setChangeRequestModal(false);
    }
    previewFileModalRef.current = previewFileModal;

    function closeFilePreviewModal() {
        setFilePreviewModal(false);
        setChangeRequestModal(true);
    }

    return (
        <>
            { isLoading && <Loader /> }

            {/* Change Requests Section */}
            <div id="changeRequestsContainer" className="copilot-filter-layout">
                {/* Filters */}
                <aside className="copilot-filter-rail">
                    <h2 className="copilot-filter-rail__title">Filter by</h2>

                    <label className="form-label">Change Request ID</label>
                    <input type="text" className="form-control mb-3" placeholder="Enter Change Request ID" name='crName' value={filterParam.crName} onChange={(e) => handleInputChange(e)} />

                    <label className="form-label">Request Status</label>
                    <select className="form-select mb-3" name='seletedStatus' value={filterParam.seletedStatus} onChange={(e) => handleInputChange(e)}>
                        <option value={''}>All Values</option>
                        {
                            data.statusList && data.statusList.map((item, index) => (
                                <option value={item.value} key={index}>{item.label}</option>
                            ))
                        }
                    </select>

                    <label className="form-label">Urgency</label>
                    <select className="form-select mb-3" name='urgency' value={filterParam.urgency} onChange={(e) => handleInputChange(e)}>
                        <option value={''}>All Values</option>
                        {
                            data.urgencyList && data.urgencyList.map((item, index) => (
                                <option value={item.value} key={index}>{item.label}</option>
                            ))
                        }
                    </select>

                    <label className="form-label">Sort By</label>
                    <select className="form-select mb-3" name='sortType' value={filterParam.sortType} onChange={(e) => handleInputChange(e)}>
                        <option value={'Recent'}>Newest Opened</option>
                        <option value={'RecentlyUpdated'}>Recently Updated</option>
                        <option value={'crName'}>Change Request ID</option>
                    </select>

                    <label className="form-label">Keyword</label>
                    <input type="text" className="form-control mb-3" placeholder="Search..." name='searchText' value={filterParam.searchText} onChange={(e) => handleInputChange(e)} />

                    <div className="mb-3">
                        <input className="form-check-input" type="checkbox" name="hideClosed" id="hideClosedItemsCR" checked={filterParam.hideClosed} onChange={(e) => handleHideClosedChange(e)} />
                        <label className="form-check-label ps-1" htmlFor="hideClosedItemsCR">Hide Closed Items</label>
                    </div>

                    {
                        filterParam.incApproved ? (
                            <button className="btn btn-primary w-100 mb-3" type="button" onClick={() => clearFilter()}>Clear</button>
                        ) : ''
                    }

                    <button className="btn btn-primary w-100" type='button' onClick={() => onApplyFilter()}>
                        Apply
                    </button>
                </aside>

                {/* Change Requests List */}
                <main className="flex-grow-1 min-w-0 ms-lg-4 mt-3 mt-lg-0">

                    {
                        pagination.totalPage > 1 && (
                            <div className="row px-2 mb-2" >
                                <div className="col-12 background py-2 text-end">
                                    <button className="btn btn-primary me-2 shrink" onClick={() => changePage(pagination.pageNo - 1)} disabled={pagination.pageNo === 1}>Previous</button>
                                    {pagination.pageNo}&nbsp;/&nbsp;{pagination.totalPage}
                                    <button className="btn btn-primary ms-2 shrink" onClick={() => changePage(pagination.pageNo + 1)} disabled={pagination.pageNo >= pagination.totalPage}>Next</button>
                                </div>
                            </div>
                        )
                    }

                    {
                        changeRequestList.length === 0 ?
                            <div className='text-center'>
                                <h6>No Data Available</h6>
                            </div>
                        :
                            changeRequestList.map((item, index) => (
                                <div
                                    key={index}
                                    className="copilot-changelog-card copilot-support-list-card mb-3 cursor-pointer"
                                    role="button"
                                    tabIndex={0}
                                    onClick={() => openChangeRequestModal(item)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            openChangeRequestModal(item);
                                        }
                                    }}
                                >
                                    <div
                                        className="copilot-changelog-card__accent copilot-changelog-card__accent--muted"
                                        aria-hidden
                                    />
                                    <div className="copilot-changelog-card__body">
                                        <h3 className="copilot-changelog-section-title text-primary mb-2">{item.Name}</h3>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <p className="text-muted small mb-1">Assigned to: {item['Assigned_To__r.Name']}</p>
                                                <p className="text-muted small mb-1">Functionality: {item.Functionality__c}</p>
                                                <p className="text-muted small mb-1">Last Modified Date: {dayjs(item.LastModifiedDate).format('YYYY-MM-DD')}</p>
                                                {
                                                    item['Case_ID__r.CaseNumber'] &&
                                                    <p className="text-muted small mb-1">Ticket Number: <button type="button" className="btn btn-link p-0 text-primary text-decoration-none" onClick={(e) => { e.stopPropagation(); onNavigate && onNavigate('ticket', item['Case_ID__c']); }}>{item['Case_ID__r.CaseNumber']}</button></p>
                                                }
                                                {
                                                    item.Feature_Request__c &&
                                                    <p className="text-muted small mb-1">
                                                        Feature Request ID:
                                                        <a href={'/feature-requests?Id='+ item.Feature_Request__c + '&email=' + data.userEmail} className="text-primary text-decoration-none"> {item['Feature_Request__r.Name']}</a>
                                                    </p>
                                                }
                                            </div>
                                            <div className="col-md-6">
                                                <p className="text-muted small mb-1">Project: {item['Project__r.Name']}</p>
                                                <p className="text-muted small mb-1">Request Status: {item.Status__c}</p>
                                                <p className="text-muted small mb-1">Created Date: {dayjs(item.LastModifiedDate).format('DD/MM/YYYY')}</p>
                                                {
                                                    item.Jira_URL__c &&
                                                    <p className="text-muted small mb-1">Jira ID: {item.Jira_URL__c}</p>
                                                }
                                            </div>
                                        </div>
                                        <p className="my-2 small text-body mb-0">{item.Change_Request_Summary__c}</p>
                                    </div>
                                </div>
                            ))
                    }

                    {
                        pagination.totalPage > 1 && (
                            <div className="row px-2 mb-2" >
                                <div className="col-12 background py-2 text-end">
                                    <button className="btn btn-primary me-2 shrink" onClick={() => changePage(pagination.pageNo - 1)} disabled={pagination.pageNo === 1}>Previous</button>
                                    {pagination.pageNo}&nbsp;/&nbsp;{pagination.totalPage}
                                    <button className="btn btn-primary ms-2 shrink" onClick={() => changePage(pagination.pageNo + 1)} disabled={pagination.pageNo >= pagination.totalPage}>Next</button>
                                </div>
                            </div>
                        )
                    }

                </main>
            </div>

            {/* Change request detail — same modal family as support tickets */}
            { changeRequestModal && <>
                <div
                    id="changeRequestModal"
                    className="modal fade show copilot-ticket-detail-modal-root"
                    tabIndex="-1"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="crModalTitle"
                    style={{ display: 'block' }}
                >
                    <div
                        className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable px-2 min-w-0"
                        role="document"
                        style={{ maxWidth: 'min(960px, calc(100vw - 1.5rem))' }}
                    >
                        <div className="modal-content copilot-ticket-detail-modal d-flex flex-column" style={{ maxHeight: 'min(90vh, 880px)' }}>
                            <div className="copilot-ticket-detail-modal__accent" aria-hidden />
                            { isEmptyObject(changeRequestDetails) ? (
                                <>
                                    <div className="modal-header border-0 copilot-ticket-detail-modal__header pb-0">
                                        <h2 id="crModalTitle" className="copilot-changelog-section-title mb-0">No change request available</h2>
                                        <button type="button" className="btn-close" aria-label="Close" onClick={() => closeChangeRequestModal()} />
                                    </div>
                                    <div className="modal-body copilot-ticket-detail-modal__body pt-2">
                                        <p className="text-body-secondary small mb-0">We could not load this change request. It may have been removed or you may not have access.</p>
                                    </div>
                                    <div className="modal-footer border-0 copilot-ticket-detail-modal__footer gap-2">
                                        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => closeChangeRequestModal()}>Close</button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="modal-header border-0 copilot-ticket-detail-modal__header">
                                        <div className="flex-grow-1 min-w-0 pe-2">
                                            <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
                                                <h2 id="crModalTitle" className="copilot-changelog-section-title mb-0 text-truncate">
                                                    {changeRequestDetails.Name}
                                                </h2>
                                                {changeRequestDetails.Status__c && (
                                                    <span className="badge rounded-pill text-bg-primary">
                                                        {changeRequestDetails.Status__c}
                                                    </span>
                                                )}
                                                {changeRequestDetails.Urgency__c && (
                                                    <span className="badge rounded-pill bg-body-secondary text-body border">
                                                        {changeRequestDetails.Urgency__c}
                                                    </span>
                                                )}
                                            </div>
                                            {changeRequestDetails.Change_Request_Summary__c && (
                                                <p className="text-body-secondary small mb-0 text-truncate" title={changeRequestDetails.Change_Request_Summary__c}>
                                                    {changeRequestDetails.Change_Request_Summary__c}
                                                </p>
                                            )}
                                        </div>
                                        <button type="button" className="btn-close flex-shrink-0" aria-label="Close" onClick={() => closeChangeRequestModal()} />
                                    </div>

                                    <div className="modal-body flex-grow-1 overflow-auto min-h-0 copilot-ticket-detail-modal__body pt-0">
                                        <div className="copilot-ticket-detail-meta bg-body-tertiary border rounded-3 p-3 mb-3">
                                            <div className="row g-2 g-md-3 small">
                                                <div className="col-12 col-md-6">
                                                    <div className="copilot-ticket-detail-meta__row">
                                                        <span className="copilot-ticket-detail-meta__label">Assigned to</span>
                                                        <span className="text-body">{changeRequestDetails['Assigned_To__r.Name']}</span>
                                                    </div>
                                                    <div className="copilot-ticket-detail-meta__row">
                                                        <span className="copilot-ticket-detail-meta__label">Functionality</span>
                                                        <span className="text-body">{changeRequestDetails.Functionality__c}</span>
                                                    </div>
                                                    <div className="copilot-ticket-detail-meta__row">
                                                        <span className="copilot-ticket-detail-meta__label">Last modified</span>
                                                        <span className="text-body">{dayjs(changeRequestDetails.LastModifiedDate).format('YYYY-MM-DD h:mm A')}</span>
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-6">
                                                    <div className="copilot-ticket-detail-meta__row">
                                                        <span className="copilot-ticket-detail-meta__label">Project</span>
                                                        <span className="text-body">{changeRequestDetails['Project__r.Name']}</span>
                                                    </div>
                                                    {changeRequestDetails['Case_ID__r.CaseNumber'] && (
                                                        <div className="copilot-ticket-detail-meta__row">
                                                            <span className="copilot-ticket-detail-meta__label">Ticket</span>
                                                            <span>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-link btn-sm p-0 text-start"
                                                                    onClick={() => { closeChangeRequestModal(false); onNavigate && onNavigate('ticket', changeRequestDetails['Case_ID__c']); }}
                                                                >
                                                                    {changeRequestDetails['Case_ID__r.CaseNumber']}
                                                                </button>
                                                            </span>
                                                        </div>
                                                    )}
                                                    {changeRequestDetails.Feature_Request__c && (
                                                        <div className="copilot-ticket-detail-meta__row">
                                                            <span className="copilot-ticket-detail-meta__label">Feature request</span>
                                                            <span>
                                                                <a
                                                                    className="small"
                                                                    href={`/feature-requests?Id=${changeRequestDetails.Feature_Request__c}&email=${data.userEmail}`}
                                                                >
                                                                    {changeRequestDetails['Feature_Request__r.Name']}
                                                                </a>
                                                            </span>
                                                        </div>
                                                    )}
                                                    <div className="copilot-ticket-detail-meta__row">
                                                        <span className="copilot-ticket-detail-meta__label">Opened</span>
                                                        <span className="text-body">
                                                            {dayjs(changeRequestDetails.CreatedDate || changeRequestDetails.LastModifiedDate).format('YYYY-MM-DD h:mm A')}
                                                        </span>
                                                    </div>
                                                    {changeRequestDetails.Jira_URL__c && (
                                                        <div className="copilot-ticket-detail-meta__row">
                                                            <span className="copilot-ticket-detail-meta__label">Jira</span>
                                                            <span className="text-body text-break">
                                                                {/^https?:\/\//i.test(String(changeRequestDetails.Jira_URL__c)) ? (
                                                                    <a href={changeRequestDetails.Jira_URL__c} target="_blank" rel="noopener noreferrer">
                                                                        {changeRequestDetails.Jira_URL__c}
                                                                    </a>
                                                                ) : (
                                                                    changeRequestDetails.Jira_URL__c
                                                                )}
                                                            </span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        <section className="mb-3">
                                            <h3 className="copilot-changelog-detail-section-title">Request summary</h3>
                                            <div className="copilot-ticket-detail-summary">
                                                <div className="copilot-ticket-detail-form-field">
                                                    <label className="copilot-ticket-detail-form-label" htmlFor="cr-detail-title-readonly">Title</label>
                                                    <div id="cr-detail-title-readonly" className="copilot-ticket-detail-form-readonly">
                                                        {changeRequestDetails.Change_Request_Summary__c}
                                                    </div>
                                                </div>
                                                <div className="copilot-ticket-detail-form-field copilot-ticket-detail-form-field--spaced">
                                                    <span className="copilot-ticket-detail-form-label">Description</span>
                                                    <div
                                                        className="copilot-ticket-detail-description copilot-ticket-detail-form-textarea-mirror"
                                                        style={{ whiteSpace: "pre-wrap", lineHeight: "1.5", maxHeight: "min(40vh, 320px)", overflowY: "auto" }}
                                                    >
                                                        {changeRequestDetails.Change_Request_Details__c && /<[a-z][\s\S]*>/i.test(changeRequestDetails.Change_Request_Details__c) ? (
                                                            <span style={{ whiteSpace: "pre-wrap" }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(changeRequestDetails.Change_Request_Details__c) }} />
                                                        ) : (
                                                            <span className="text-body">{changeRequestDetails.Change_Request_Details__c || 'No description available'}</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </section>

                                        <section className="mb-3">
                                            <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
                                                <h3 className="copilot-changelog-detail-section-title mb-0">Attachments</h3>
                                            </div>
                                            <div className="copilot-ticket-detail-upload mb-3">
                                                <div className="d-flex flex-wrap align-items-stretch gap-2">
                                                    <div className="flex-grow-1 min-w-0" style={{ minWidth: '12rem' }}>
                                                        <label className="copilot-ticket-detail-form-label" htmlFor="change-request-file-upload">Add a file</label>
                                                        <input
                                                            type="file"
                                                            ref={fileUploadRef}
                                                            id="change-request-file-upload"
                                                            className="form-control form-control-sm rounded-3"
                                                            accept="*"
                                                        />
                                                    </div>
                                                    <div className="d-flex align-items-end">
                                                        <button type="button" className="btn btn-sm btn-primary rounded-3 px-3" onClick={handleFileUpload}>
                                                            <i className="fa-solid fa-cloud-arrow-up me-1" aria-hidden />
                                                            Upload
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-2 copilot-file-attachment-row">
                                                { !changeRequestDetails.fileList || changeRequestDetails.fileList.length === 0 ? (
                                                    <div className="col-12">
                                                        <p className="text-body-secondary small mb-0">No files attached.</p>
                                                    </div>
                                                ) : (
                                                    changeRequestDetails.fileList.map((file, index) => (
                                                        <div className="col min-w-0" key={index}>
                                                            <div className="border rounded-3 p-3 text-center copilot-file-attachment-card copilot-ticket-detail-file-card h-100 d-flex flex-column">
                                                                <i className="fa-solid fa-file-lines fa-2x text-body-secondary mb-2" aria-hidden />
                                                                <p className="small text-primary mb-1 text-break">
                                                                    <span
                                                                        role="button"
                                                                        tabIndex={0}
                                                                        className="d-inline-block text-decoration-underline"
                                                                        style={{ maxWidth: '100%' }}
                                                                        data-testid="cr-attachment-open"
                                                                        data-doc-id={file.docId || undefined}
                                                                        onKeyDown={(e) => e.key === 'Enter' && openChangeRequestAttachment(file)}
                                                                        onClick={() => openChangeRequestAttachment(file)}
                                                                    >
                                                                        {file.name || file.Name}
                                                                    </span>
                                                                </p>
                                                                <p className="text-body-secondary small mb-0 mt-auto">Added {dayjs(file.date).format('MMM D, YYYY')}</p>
                                                            </div>
                                                        </div>
                                                    ))
                                                ) }
                                            </div>
                                        </section>

                                        <section className="pt-2 mt-1 border-top border-secondary-subtle copilot-ticket-detail-activity">
                                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                                                <h3 className="copilot-changelog-detail-section-title mb-0">Conversation</h3>
                                                <div className="d-flex align-items-center gap-2 copilot-ticket-detail-sort">
                                                    <label className="text-body-secondary small mb-0 text-nowrap" htmlFor="crChatterSort">Sort</label>
                                                    <select
                                                        ref={crChatterSortRef}
                                                        id="crChatterSort"
                                                        className="form-select form-select-sm copilot-ticket-detail-sort__select"
                                                        onChange={(e) => sortCRComments(e)}
                                                        aria-label="Sort comments"
                                                    >
                                                        <option value="Most Recent Activity">Newest first</option>
                                                        <option value="Oldest First">Oldest first</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="copilot-ticket-detail-composer mb-4">
                                                <form onSubmit={postNewCRComment} className="copilot-ticket-detail-composer__form">
                                                    <label className="copilot-ticket-detail-form-label" htmlFor="crChatterNewPost">Share an update</label>
                                                    <textarea
                                                        id="crChatterNewPost"
                                                        name="crChatterNewPost"
                                                        rows="4"
                                                        className="form-control copilot-ticket-detail-composer__textarea"
                                                        placeholder="Write a comment for the team…"
                                                    />
                                                    <input type="hidden" name="crCommentId" value={changeRequestDetails.Id} />
                                                    <div className="copilot-ticket-detail-composer__footer">
                                                        <button type="submit" className="btn btn-sm btn-primary rounded-3 px-4">
                                                            <i className="fa-solid fa-paper-plane me-1" aria-hidden />
                                                            Post
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>

                                            <div id="crCommentsContainer" className="copilot-ticket-detail-comment-list d-flex flex-column gap-3">
                                                {changeRequestCommentList && changeRequestCommentList.map((item, index) => (
                                                    <article className={`copilot-ticket-detail-comment${isSystemFeedItem(item.Type) ? ' copilot-ticket-detail-comment--system' : ''}`} key={item.Id || index}>
                                                        <div className="copilot-ticket-detail-comment__inner">
                                                            <div className="copilot-ticket-detail-comment__header">
                                                                <span className="copilot-ticket-detail-avatar" aria-hidden>
                                                                    {commentInitials(item['CreatedBy.Name'])}
                                                                </span>
                                                                <div className="copilot-ticket-detail-comment__meta min-w-0">
                                                                    <div className="fw-semibold text-body text-truncate" title={item['CreatedBy.Name']}>
                                                                        {item['CreatedBy.Name']}
                                                                        {isSystemFeedItem(item.Type) && (
                                                                            <span className="badge text-bg-light border ms-2 fw-normal">Update</span>
                                                                        )}
                                                                    </div>
                                                                    <time className="text-body-secondary small" dateTime={item.CreatedDate}>
                                                                        {dayjs(item.CreatedDate).format('MMM D, YYYY · h:mm A')}
                                                                    </time>
                                                                </div>
                                                            </div>
                                                            <div
                                                                className={`copilot-ticket-detail-comment__body copilot-comment-body small${isSystemFeedItem(item.Type) ? ' text-body-secondary fst-italic' : ''}`}
                                                                role="presentation"
                                                            >
                                                                <FeedBody
                                                                    html={sanitizeCommentBody(item.Body)}
                                                                    imageCache={imageCache}
                                                                    cacheVersion={imageCacheVersion}
                                                                    kind="changeRequest"
                                                                    recordId={changeRequestDetails.Id}
                                                                    onImagesSettled={onImagesSettled}
                                                                    onImageClick={handleCommentImageClick}
                                                                />
                                                                <FeedAttachments files={item.attachments} onOpen={handleFeedAttachmentOpen} />
                                                            </div>
                                                        </div>

                                                        {item.comments && item.comments.length > 0 && (
                                                            <div className="copilot-ticket-detail-thread">
                                                                {item.comments
                                                                    .sort((a, b) => new Date(a.CreatedDate) - new Date(b.CreatedDate))
                                                                    .map((reply, reIndex) => (
                                                                        <div className="copilot-ticket-detail-reply" key={reply.Id || reIndex}>
                                                                            <div className="copilot-ticket-detail-comment__header copilot-ticket-detail-comment__header--reply">
                                                                                <span className="copilot-ticket-detail-avatar copilot-ticket-detail-avatar--sm" aria-hidden>
                                                                                    {commentInitials(reply['CreatedBy.Name'])}
                                                                                </span>
                                                                                <div className="copilot-ticket-detail-comment__meta min-w-0">
                                                                                    <div className="fw-semibold text-body small text-truncate" title={reply['CreatedBy.Name']}>
                                                                                        {reply['CreatedBy.Name']}
                                                                                    </div>
                                                                                    <time className="text-body-secondary" style={{ fontSize: '0.75rem' }} dateTime={reply.CreatedDate}>
                                                                                        {dayjs(reply.CreatedDate).format('MMM D, YYYY · h:mm A')}
                                                                                    </time>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                className="copilot-ticket-detail-comment__body copilot-comment-body small"
                                                                                role="presentation"
                                                                            >
                                                                                <FeedBody
                                                                                    html={sanitizeCommentBody(reply.CommentBody)}
                                                                                    imageCache={imageCache}
                                                                                    cacheVersion={imageCacheVersion}
                                                                                    kind="changeRequest"
                                                                                    recordId={changeRequestDetails.Id}
                                                                                    onImagesSettled={onImagesSettled}
                                                                                    onImageClick={handleCommentImageClick}
                                                                                />
                                                                                <FeedAttachments files={reply.attachments} onOpen={handleFeedAttachmentOpen} />
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                            </div>
                                                        )}

                                                        <form onSubmit={addReply} className="copilot-ticket-detail-reply-form">
                                                            <input type="hidden" name="replyId" value={item.Id} />
                                                            <label className="visually-hidden" htmlFor={`cr-reply-${item.Id}`}>Reply to this comment</label>
                                                            <textarea
                                                                id={`cr-reply-${item.Id}`}
                                                                rows="2"
                                                                name="reply"
                                                                className="form-control form-control-sm"
                                                                placeholder="Write a reply…"
                                                            />
                                                            <div className="copilot-ticket-detail-reply-form__actions">
                                                                <button type="submit" className="btn btn-sm btn-outline-primary rounded-3">
                                                                    Send reply
                                                                </button>
                                                            </div>
                                                        </form>
                                                    </article>
                                                ))}
                                            </div>
                                        </section>
                                    </div>

                                    <div className="modal-footer border-0 copilot-ticket-detail-modal__footer gap-2">
                                        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => closeChangeRequestModal()}>
                                            Close
                                        </button>
                                    </div>
                                </>
                            ) }
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade show copilot-ticket-detail-modal-backdrop" />
            </> }

            <FilePreviewModal
                isOpen={filePreviewModal}
                fileUrl={data.curFileUrl}
                fileName={data.curFileName}
                kind={data.curFileKind}
                onClose={() => closeFilePreviewModal()}
            />
        </>

    )
}

export default ChangeRequestTab;